<div class="bn-alert-notice bn-imp-notice" *ngIf="!hideAlert">
    <div class="bn-icon">
        <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
    </div>
    <div class="bn-content">
        <div class="bn-content-text">
            <div class="bn-content-text-sub">
                <div class="bn-content-text-title">Important notice</div>
                <div class="bn-content-close">
                    <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                        (click)="onClose()" />
                </div>
            </div>
            <ng-container *ngIf="autoPayForce; else notautoPayForce">
                <div class="bn-desc-text">
                    {{'An automatic payment is scheduled for ' }}<span class="bn-deduction-day">{{ deductionDay | customDateFormat }}</span>{{' and it can not be stopped.'}}
                </div>
                <hr class="bn-hr-margin bn-hr-border">
                <div class="bn-agent-text">Do you want to make an additional payment?</div>
            </ng-container>
            <ng-template #notautoPayForce>
            <ng-container *ngIf="!isPaymentFAils; else paymentFails">
                <div>This policy is cancelled, payments of the balance owed to us will NOT reinstate this policy.</div>
                <hr class="bn-hr-margin bn-hr-border">
                <div class="bn-contact-agent bn-agent-text">
                    <ng-container *ngIf="isAcmic; else maAssistance">
                        <div class="font-weight-500 mb-1">
                                Contact us for assistance
                        </div>
                        <div class="bn-contact-agent-info">
                            <div class="bn-agent-phone mt-0">
                                <div>
                                    {{ 'PHONE' | translate }}
                                </div>
                                <div class="ml-1">
                                    <a href="tel:1-844-295-4500" class="mapfre link red-text">
                                        {{ '1-844-295-4500' }}</a>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #maAssistance>
                        <div class="font-weight-500 mb-2">
                                Contact your agent for assistance
                        </div>
                        <div class="bn-contact-agent-info">
                            <div>{{ agentName }}</div>
                            <div class="bn-agent-phone" *ngIf="agentPhoneNumber">
                                <div>
                                    {{ 'PHONE' | translate }}
                                </div>
                                <div class="ml-1">
                                    <a href="tel:{{agentPhoneNumber}}" class="mapfre link red-text">
                                        {{ agentPhoneNumber | formatPhone }}</a>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    
                </div>
            </ng-container>
            <ng-template #paymentFails>
                <ng-container *ngIf="!isInvalidRouting; else inValidRoute">
                    <div class="lh-18" [ngClass]="{'lh-20':isAcmic}">There was a problem paying your bill, please review your details.</div>
                </ng-container>
                <ng-template #inValidRoute>
                    <div class="lh-18" [ngClass]="{'lh-20':isAcmic}">Please review and enter a valid routing number.</div>
                </ng-template>
            </ng-template>
        </ng-template>
        </div>
    </div>
</div>